module.exports = __webpack_public_path__ + "static/media/pricing-plan.4a58b5ab.png";